module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_login) ? _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {
    staticClass: "card-box-0",
    staticStyle: {
      "padding": "0 1em"
    }
  }, _vm._l((_vm.feeds), function(feed, index) {
    return _c('div', {
      staticClass: "card card-strip",
      staticStyle: {
        "border-bottom": "#eeeded solid",
        "padding": "8px 0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.clickNotifications(_vm.noti.notification_ref, _vm.noti.notification_url)
        }
      }
    }, [(feed.following_type == '1a' || feed.following_type == '1b') ? _c('div', [(feed.following_recent_update.length != 0) ? _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_recent_update.update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('span', [(feed.following_recent_update.update_name && (feed.following_recent_update.update_name != '')) ? _c('h6', [_vm._v(_vm._s(feed.following_recent_update.update_name))]) : _vm._e()]), _vm._v(" "), _c('div', [(feed.following_recent_update.update_cta && (feed.following_recent_update.update_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_recent_update.update_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_recent_update.update_time_ago))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (feed.following_type == 3) ? _c('div', [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('span', [(feed.following_update_name && (feed.following_update_name != '')) ? _c('h6', [_vm._v(_vm._s(feed.following_update_name))]) : _vm._e(), _vm._v(" "), (feed.following_update_cta && (feed.following_update_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_update_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_update_time_ago))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]) : _vm._e(), _vm._v(" "), (feed.following_type == 4) ? _c('div', [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('div', {}, [_c('span', [(feed.following_update_name && (feed.following_update_name != '')) ? _c('h4', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(feed.following_update_name))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(feed.following_update_details))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]) : _vm._e()])])
  }))])])]), _vm._v(" "), _c('component-footer', {
    key: _vm.componentMenuBottomkey
  })], 1) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ef3570"}!./src/pages/Feeds/template.html
// module id = 566
// module chunks = 0